import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 24px;
    font-family: ${theme.v2.font.family.primary};
  `}
`;

export const ContentWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 40px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
      gap: 24px;
    }
  `}
`;

export const TextContent = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
`;

export const Description = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 24px;
    color: ${theme.v2.colors.neutral.lowDark};
    margin: 0;
  `}
`;

export const ImageWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 100%;
    }
  `}
`;

export const SnappyImage = styled.img`
  ${({ theme }) => css`
    width: 252px;
    height: 252px;
    object-fit: contain;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 200px;
      height: 200px;
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      width: 160px;
      height: 160px;
    }
  `}
`;

export const Actions = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 16px;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      flex-direction: column;
    }
  `}
`;
